export default __webpack_public_path__ + "assets/images/11583a356fc9c1b719339947a526541e.svg";